import { useState, useEffect } from "react";
import axios from "axios";
import { shimmer, toBase64 } from "./FileShimmer";
import { getFileUsingGUID } from "../constant";
export const BASE_64 = "base64";

function detectMimeType(b64) {
  var signatures = {
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    '/9j/': 'image/jpg',
  };
  for (var s in signatures) {
    if (b64.indexOf(s) === 0) {
      return signatures[s];
    }
  }
  var base64result = b64.split(',')[1] || '';
  for (var s in signatures) {
    if (base64result.indexOf(s) === 0) {
      return signatures[s];
    }
  }
  return '';
}

export const base64ToSrc = (base64String) => {
  return `data:${detectMimeType(
    base64String
  )};base64,${base64String}`;
};

export const downloadFileAsBuffer = async (url) => {
  try {
    const response = await axios.get(url, {
      responseType: 'arraybuffer', // Set responseType to 'arraybuffer' to receive the data as a Buffer
    });

    return Buffer.from(response.data); // Return the Buffer containing file data
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error; // Rethrow the error to be caught by the caller
  }
};


export const FileViewer = ({ id, width = '8.5rem', height = '8.5rem' }) => {
  const url = `${getFileUsingGUID}/${id}?preview=true`;
  const [base64url, setBase64Url] = useState('');

  useEffect(() => {
    const downloadAndConvertFile = async () => {
      try {
        const buffer = await downloadFileAsBuffer(url);
        const base64String = buffer.toString(BASE_64);
        const src = base64ToSrc(base64String);
        setBase64Url(src);
      } catch (error) {
        console.error('Error downloading and converting file:', error);
      }
    };

    downloadAndConvertFile();
  }, [url]);

  return (<>
    {
      (!base64url) ?
        <div
          style={{
            width: width,
            height: height,
            backgroundImage: `url(data:image/svg+xml;base64,${toBase64(shimmer(80, 64))})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        /> :
        <img
          src={base64url}
          alt={"file viewer image"}
          className={'object-contain'}
          style={{ width: { width }, height: { height } }}
        />
    }
  </>
  );
}